export const GET_INTERCOM_TARIFFS = 'GET_INTERCOM_TARIFFS';
export const GET_INTERCOM_ACTION = 'GET_INTERCOM_ACTION';
